import { formatCash } from '@/shared/utils/currency';
import styled from 'styled-components';

import { ProgressBarCursorIcon } from '@/assets/icons/info-icons/progressBarCursor';
import { themeVar } from '@/styles/theme';
import { IInvestorDetailsProgressBar } from './types';

interface ProgressBarProps {
  progressBarData: IInvestorDetailsProgressBar;
}

const ProgressBar = ({ progressBarData }: ProgressBarProps) => {
  if (!progressBarData) return <></>;
  return (
    <ProgressBarContainer>
      <ProgressBarWrap>
        <ProgressCursor margin={(progressBarData?.goal * 100) / (progressBarData?.totalGoal ?? 0)}>
          <CursorTitle>{formatCash(progressBarData.goal)}</CursorTitle>
          <ProgressBarCursorIcon fill={themeVar('font.weak')} />
        </ProgressCursor>
        <ProgressWrap>
          <ProgressTitle>{formatCash(progressBarData.total)}</ProgressTitle>
          <Progress isFull={!!progressBarData?.isGoalAchieved} width={(progressBarData?.total * 100) / (progressBarData?.totalGoal ?? 0) || 0} />
        </ProgressWrap>
      </ProgressBarWrap>
      <StartEnd>
        <StartEndTitle>{formatCash(0)}</StartEndTitle>
        <StartEndTitle>{formatCash(progressBarData.totalGoal)}</StartEndTitle>
      </StartEnd>
    </ProgressBarContainer>
  );
};

export default ProgressBar;

const StartEndTitle = styled.div`
  font-family: 'Blinker', serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  color: ${themeVar('font.weak')};
`;

const StartEnd = styled.div`
  margin-top: -12px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ProgressTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-family: 'Blinker', serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 12px;
  text-align: center;
  color: ${themeVar('context.light')};
`;

const Progress = styled.div<{ width: number | string; isFull: boolean }>`
  display: flex;
  width: ${({ width }) => `${width}%`};
  height: 20px;
  background: ${({ isFull }) => (isFull ? themeVar('context.error') : themeVar('context.success'))};
  transition: 0.3s ease-in-out;
`;

const ProgressWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  width: 100%;
  height: 20px;
  border-radius: 10px;
  background: #94e3a1;
  max-height: 20px;
`;

const CursorTitle = styled.div`
  font-family: Blinker, serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  text-align: left;
  margin-bottom: -7px;
  color: ${themeVar('font.weak')};
`;

const ProgressCursor = styled.div<{ margin: number }>`
  display: flex;
  margin-left: ${({ margin }) => `calc(${margin}% - 14px)`};
  align-items: center;
  align-self: flex-start;
  flex-direction: column;
  gap: 4px;
  width: 28px;
  min-width: 28px;
  max-width: 28px;
  transition: 0.3s ease-in-out;
`;

const ProgressBarWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  padding: 20px 30px;
`;
